var _path, _path2, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVedetteFavicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 259,
    viewBox: "0 0 259 259",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M236.578 191.289L129.424 253.154L22.2699 191.289L22.2699 67.5585L129.424 5.69318L236.578 67.5585L236.578 191.289Z",
    stroke: "url(#paint0_linear_1152_5453)",
    strokeWidth: 9.86086
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M214.163 178.347L129.426 227.27L44.6888 178.347L44.6888 80.5014L129.426 31.5785L214.163 80.5014L214.163 178.347Z",
    stroke: "url(#paint1_linear_1152_5453)",
    strokeWidth: 9.86086
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 93.1914,
    y: 129.424,
    width: 51.7695,
    height: 51.7695,
    transform: "rotate(-45 93.1914 129.424)",
    fill: "url(#paint2_linear_1152_5453)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1152_5453",
    x1: 96.9026,
    y1: 129.424,
    x2: -0.0000115517,
    y2: 129.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4285F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6C8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1152_5453",
    x1: 103.409,
    y1: 129.424,
    x2: 25.8867,
    y2: 129.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4285F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6C8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1152_5453",
    x1: 176.471,
    y1: 148.642,
    x2: 55.6697,
    y2: 143.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5897FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B78FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVedetteFavicon);
export default __webpack_public_path__ + "static/media/vedette_favicon.5c96d4989c9f2487d08380301499da6f.svg";
export { ForwardRef as ReactComponent };